import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import PropTypes from "prop-types";
import moment from "moment";
import * as _ from "lodash";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";

import { FaEdit, FaSave } from "react-icons/fa";
import config from "../../../config";
// core components
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import Card from "../../../components/Card/Card";
import CardAvatar from "../../../components/Card/CardAvatar";
import CardBody from "../../../components/Card/CardBody";
import GridContainer from "../../../components/Grid/GridContainer";
import { getOfferByAdmin, getAllCategories } from "./queries";
import { updateOfferByAdmin } from "./mutation";
import styles from "./style";
import { Dialog } from "../../../components";

const OfferStatus = {
  PUBLISHED: "PUBLISHED",
  PAUSED: "PAUSED",
};

const OFFER_SUBJECTS = [
  { value: "Men", label: "Men" },
  { value: "Women", label: "Women" },
  { value: "Family", label: "Family" },
];

const OFFER_WEEK_DAYS = [
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
  { value: 0, label: "Sun" },
];

const parseOfferSubject = (subject) => {
  if (!subject) return [];
  try {
    const parsed = JSON.parse(subject);
    return Array.isArray(parsed) ? parsed : [subject];
  } catch (error) {
    return [subject];
  }
};

const normalizeTimeForInput = (value) => {
  if (!value) return "";
  const match = String(value).match(/(\d{1,2}):(\d{2})/);
  if (!match) return "";
  return `${match[1].padStart(2, "0")}:${match[2]}`;
};

const getPlacementTimeState = (placementTimes = []) => {
  if (!placementTimes.length) {
    return {
      availableDays: [0, 1, 2, 3, 4, 5, 6],
      startHour: "09:00",
      endHour: "17:00",
    };
  }

  const availableDays = [...new Set(placementTimes.map((time) => time.day_of_week))].sort(
    (a, b) => a - b
  );

  return {
    availableDays,
    startHour: normalizeTimeForInput(placementTimes[0].start_hour) || "09:00",
    endHour: normalizeTimeForInput(placementTimes[0].end_hour) || "17:00",
  };
};

const getDayLabels = (days = []) => OFFER_WEEK_DAYS
  .filter((day) => days.includes(day.value))
  .map((day) => day.label)
  .join(", ");

const getSubjectLabels = (subject) => {
  const values = parseOfferSubject(subject);
  return OFFER_SUBJECTS
    .filter((item) => values.includes(item.value))
    .map((item) => item.label)
    .join(", ");
};

class Detail extends Component {
  constructor(props) {
    super(props);
    const { detailOffer, listCategory } = this.props;
    this.state = {
      edit: false,
      detailOffer,
      categoryId: undefined,
      listCategory,
      seeMore: false,
      open: false,
      titleDialog: "",
      content: "",
      offerEndDetail: undefined,
      offerStartDetail: undefined,
      active: undefined,
      status: undefined,
      offerImages: [],
      removedImageIds: [],
      newOfferFiles: [],
      newImagePreviews: [],
      newOfferImageNames: "",
      saving: false,
    };
  }

  componentWillUnmount() {
    this.revokeNewImagePreviews();
  }

  // Ham nay chay khi edit
  componentWillReceiveProps = (nextProps) => {
    const { detailOffer, listCategory } = this.props;
    const isDiff = !_.isEqual(nextProps.detailOffer, detailOffer);
    // if (nextProps.detailOffer !== detailOffer) {
    if (isDiff) {
      this.setState({ detailOffer: nextProps.detailOffer });
    }
    if (nextProps.listCategory !== listCategory) {
      this.setState({ listCategory: nextProps.listCategory });
    }
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSwitchChange = (name) => (_event, checked) => {
    this.setState({ [name]: checked });
  };

  revokeNewImagePreviews = () => {
    const { newImagePreviews } = this.state;
    newImagePreviews.forEach((preview) => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    });
  };

  resetImageEditState = () => {
    this.revokeNewImagePreviews();
    this.setState({
      offerImages: [],
      removedImageIds: [],
      newOfferFiles: [],
      newImagePreviews: [],
      newOfferImageNames: "",
    });
  };

  onEdit = () => {
    const { edit, detailOffer } = this.state;
    if (!edit) {
      const placementState = getPlacementTimeState(detailOffer.placementTimes || []);
      this.setState({
        edit: true,
        offerTitleEdit: detailOffer.title || "",
        offerDescriptionEdit: detailOffer.description || "",
        offerQuantitiesEdit:
          detailOffer.quantities != null ? String(detailOffer.quantities) : "",
        offerRegularPriceEdit:
          detailOffer.regularPrice != null ? String(detailOffer.regularPrice) : "",
        offerPriceEdit:
          detailOffer.offerPrice != null ? String(detailOffer.offerPrice) : "",
        offerTimerEdit:
          detailOffer.offerTimer != null ? String(detailOffer.offerTimer) : "",
        offerSubjectEdit: parseOfferSubject(detailOffer.subject),
        offerAvailableDaysEdit: placementState.availableDays,
        offerStartHourEdit: placementState.startHour,
        offerEndHourEdit: placementState.endHour,
        offerImages: (detailOffer.images || []).map((img) => ({
          id: img.id,
          full: img.full,
        })),
        removedImageIds: [],
        newOfferFiles: [],
        newImagePreviews: [],
        newOfferImageNames: "",
      });
      return;
    }
    this.resetImageEditState();
    this.setState({ edit: false });
  };

  onCancelEdit = () => {
    this.resetImageEditState();
    this.setState({ edit: false });
  };

  onRemoveExistingImage = (imageId) => {
    const { offerImages, removedImageIds } = this.state;
    this.setState({
      offerImages: offerImages.filter((img) => img.id !== imageId),
      removedImageIds: [...removedImageIds, imageId],
    });
  };

  onRemoveNewImage = (index) => {
    const { newOfferFiles, newImagePreviews } = this.state;
    if (newImagePreviews[index]) {
      URL.revokeObjectURL(newImagePreviews[index]);
    }
    const nextFiles = newOfferFiles.filter((_, i) => i !== index);
    const nextPreviews = newImagePreviews.filter((_, i) => i !== index);
    this.setState({
      newOfferFiles: nextFiles,
      newImagePreviews: nextPreviews,
      newOfferImageNames: nextFiles.map((file) => file.name).join(", "),
    });
  };

  onChooseOfferImages = (event) => {
    const files = event.target.files ? Array.from(event.target.files) : [];
    this.revokeNewImagePreviews();
    const previews = files.map((file) => URL.createObjectURL(file));
    this.setState({
      newOfferFiles: files,
      newImagePreviews: previews,
      newOfferImageNames: files.map((file) => file.name).join(", "),
    });
    event.target.value = "";
  };

  uploadOfferImages = async (files) => {
    if (!files || !files.length) {
      return [];
    }
    const formData = new FormData();
    files.forEach((file, i) => {
      formData.append(i, file);
    });

    const uploadResponse = await fetch(`${config.upload}`, {
      method: "POST",
      body: formData,
    });
    const uploadResult = await uploadResponse.json();

    if (Array.isArray(uploadResult)) {
      return uploadResult.map((img) => (img.file ? img.file.uri : img.uri)).filter(Boolean);
    }
    if (uploadResult.files && Array.isArray(uploadResult.files)) {
      return uploadResult.files.map((img) => (img.file ? img.file.uri : img.uri)).filter(Boolean);
    }
    if (uploadResult.file && uploadResult.file.uri) {
      return [uploadResult.file.uri];
    }
    if (uploadResult.uri) {
      return [uploadResult.uri];
    }
    return [];
  };

  handleOfferSubjectChange = (event) => {
    this.setState({ offerSubjectEdit: event.target.value });
  };

  handleOfferDayToggle = (dayValue) => {
    const { offerAvailableDaysEdit } = this.state;
    const isSelected = offerAvailableDaysEdit.includes(dayValue);
    this.setState({
      offerAvailableDaysEdit: isSelected
        ? offerAvailableDaysEdit.filter((day) => day !== dayValue)
        : [...offerAvailableDaysEdit, dayValue],
    });
  };

  onSave = async () => {
    const {
      detailOffer,
      categoryId,
      offerEndDetail,
      offerStartDetail,
      active,
      status,
      removedImageIds,
      newOfferFiles,
      offerTitleEdit,
      offerDescriptionEdit,
      offerQuantitiesEdit,
      offerRegularPriceEdit,
      offerPriceEdit,
      offerTimerEdit,
      offerSubjectEdit,
      offerAvailableDaysEdit,
      offerStartHourEdit,
      offerEndHourEdit,
    } = this.state;
    const { updateOfferByAdmin } = this.props;
    const { id } = detailOffer;

    const regularPriceValue = Number(offerRegularPriceEdit);
    const offerPriceValue = Number(offerPriceEdit);
    if (offerPriceValue > regularPriceValue) {
      this.setState({
        open: true,
        content: "Offer price cannot be greater than regular price",
        titleDialog: "Update Offer",
      });
      return;
    }

    if (!offerSubjectEdit || !offerSubjectEdit.length) {
      this.setState({
        open: true,
        content: "Target Audience is required",
        titleDialog: "Update Offer",
      });
      return;
    }

    if (!offerAvailableDaysEdit || !offerAvailableDaysEdit.length) {
      this.setState({
        open: true,
        content: "At least one available day is required",
        titleDialog: "Update Offer",
      });
      return;
    }

    if (!offerStartHourEdit || !offerEndHourEdit) {
      this.setState({
        open: true,
        content: "Start Hour and End Hour are required",
        titleDialog: "Update Offer",
      });
      return;
    }

    const placementTimes = offerAvailableDaysEdit.map((dayOfWeek) => ({
      day_of_week: dayOfWeek,
      start_hour: offerStartHourEdit,
      end_hour: offerEndHourEdit,
    }));

    this.setState({ saving: true });
    try {
      const uploadedImages = await this.uploadOfferImages(newOfferFiles);
      const input = {
        id,
        title: offerTitleEdit,
        description: offerDescriptionEdit,
        quantities: Number(offerQuantitiesEdit) || 0,
        regularPrice: regularPriceValue,
        offerPrice: offerPriceValue,
        offerTimer: Number(offerTimerEdit) || 0,
        categoryId,
        offerEnd: offerEndDetail,
        offerStart: offerStartDetail,
        subject: JSON.stringify(offerSubjectEdit),
        placementTimes,
        active,
        status:
          status === undefined
            ? undefined
            : status
            ? OfferStatus.PUBLISHED
            : OfferStatus.PAUSED,
      };

      if (removedImageIds.length) {
        input.removedImageIds = removedImageIds;
      }
      if (uploadedImages.length) {
        input.images = uploadedImages;
      }

      await updateOfferByAdmin({
        variables: { input },
        refetchQueries: [{ query: getOfferByAdmin, variables: { id } }],
      });

      this.resetImageEditState();
      this.setState({
        edit: false,
        saving: false,
        open: true,
        content: "Completed",
        titleDialog: "Update Offer",
      });
      this.props.refetchDetailOffer();
    } catch (error) {
      const message = error && error.graphQLErrors && error.graphQLErrors[0]
        ? error.graphQLErrors[0].message
        : "Value invalid";
      this.setState({
        saving: false,
        open: true,
        content: message,
        titleDialog: "Erros Update Offer",
      });
    }
  };

  onChangeTime = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  _renderOfferImages = () => {
    const { classes } = this.props;
    const {
      edit,
      detailOffer,
      offerImages,
      newImagePreviews,
      newOfferImageNames,
    } = this.state;
    const displayImages = edit ? offerImages : ((detailOffer && detailOffer.images) || []);
    const hasImages = displayImages.length > 0 || (edit && newImagePreviews.length > 0);

    return (
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes.offerImagesSection}>
          {hasImages ? (
            <div className={classes.offerImagesGrid}>
              {displayImages.map((item) => (
                <div className={classes.offerImageItem} key={`existing-${item.id}`}>
                  <img
                    src={item.full}
                    alt={`offer-${item.id}`}
                    className={classes.offerImage}
                  />
                  {edit && (
                    <IconButton
                      className={classes.removeImageButton}
                      onClick={() => this.onRemoveExistingImage(item.id)}
                      aria-label="Remove image"
                    >
                      <CloseIcon fontSize="small" style={{ color: "#fff" }} />
                    </IconButton>
                  )}
                </div>
              ))}
              {edit && newImagePreviews.map((preview, index) => (
                <div className={classes.offerImageItem} key={`new-${index}`}>
                  <img
                    src={preview}
                    alt={`new-offer-${index}`}
                    className={classes.offerImage}
                  />
                  <IconButton
                    className={classes.removeImageButton}
                    onClick={() => this.onRemoveNewImage(index)}
                    aria-label="Remove new image"
                  >
                    <CloseIcon fontSize="small" style={{ color: "#fff" }} />
                  </IconButton>
                </div>
              ))}
            </div>
          ) : (
            <Typography className={classes.textVisited}>
              No images for this offer
            </Typography>
          )}
          {edit && (
            <>
              <input
                accept="image/*"
                id="editOfferImages"
                type="file"
                multiple
                onChange={this.onChooseOfferImages}
                className={classes.addImagesInput}
              />
              <Typography component="p" style={{ fontSize: 12, color: "#666" }}>
                {newOfferImageNames
                  ? `Selected: ${newOfferImageNames}`
                  : "Add more images for this offer"}
              </Typography>
            </>
          )}
        </div>
      </GridItem>
    );
  };

  _renderStore = () => {
    const { classes } = this.props;
    const { detailOffer, seeMore } = this.state;
    const { stores } = detailOffer;
    return (
      <GridItem xs={12} sm={12} md={10}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <Typography component="p" className={classes.textTitleStores}>
              Stores
            </Typography>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            {stores && (
              <GridContainer>
                {!seeMore
                  ? stores.slice(0, 4).map((item) => (
                      <GridItem xs={12} sm={12} md={3} key={item.id}>
                        <Link to={{ pathname: `/detailStore/${item.id}` }}>
                          <Card profile>
                            <CardAvatar profile>
                              <Avatar
                                alt="Avartar"
                                src={item.pictures || ""}
                                className={classes.avatar}
                              />
                            </CardAvatar>
                            <CardBody profile>
                              <h6 className={classes.cardCategory}>Store</h6>
                              <Typography
                                component="p"
                                className={classes.cardTitle}
                              >
                                {item.name.toUpperCase()}
                              </Typography>
                              <Typography
                                component="p"
                                className={classes.textStore}
                              >
                                {item.location}
                              </Typography>
                              <Typography
                                component="p"
                                className={classes.textStore}
                              >
                                Phone: {item.phone}
                              </Typography>
                            </CardBody>
                          </Card>
                        </Link>
                      </GridItem>
                    ))
                  : stores.map((item) => (
                      <GridItem xs={12} sm={12} md={3} key={item.id}>
                        <Link to={{ pathname: `/detailStore/${item.id}` }}>
                          <Card profile>
                            <CardAvatar profile>
                              <Avatar
                                alt="Avartar"
                                src={item.pictures || ""}
                                className={classes.avatar}
                              />
                            </CardAvatar>
                            <CardBody profile>
                              <h6 className={classes.cardCategory}>Store</h6>
                              <Typography
                                component="p"
                                className={classes.cardTitle}
                              >
                                {item.name.toUpperCase()}
                              </Typography>
                              <Typography
                                component="p"
                                className={classes.textStore}
                              >
                                {item.location}
                              </Typography>
                              <Typography
                                component="p"
                                className={classes.textStore}
                              >
                                Phone: {item.phone}
                              </Typography>
                            </CardBody>
                          </Card>
                        </Link>
                      </GridItem>
                    ))}
              </GridContainer>
            )}
          </GridItem>
          {stores && stores.length > 4 && (
            <GridItem xs={12} sm={12} md={12}>
              {!seeMore && (
                <Typography
                  component="p"
                  className={classes.seeMore}
                  onClick={() => this.setState({ seeMore: true })}
                >
                  See More
                </Typography>
              )}
            </GridItem>
          )}
        </GridContainer>
      </GridItem>
    );
  };

  render() {
    const { classes, loading, loadingListCategory } = this.props;
    if (loading || loadingListCategory) return null;
    const {
      detailOffer,
      edit,
      categoryId,
      listCategory,
      open,
      titleDialog,
      content,
      saving,
    } = this.state;
    const {
      title,
      quantities,
      offerPrice,
      regularPrice,
      offerTimer,
      saleOff,
      category,
      merchant,
      active, // boolean,
      status,
    } = detailOffer;
    const {
      offerTitleEdit,
      offerDescriptionEdit,
      offerQuantitiesEdit,
      offerRegularPriceEdit,
      offerPriceEdit,
      offerTimerEdit,
      offerSubjectEdit,
      offerAvailableDaysEdit,
      offerStartHourEdit,
      offerEndHourEdit,
    } = this.state;
    const placementDisplay = getPlacementTimeState(detailOffer.placementTimes || []);
    const subjectDisplay = getSubjectLabels(detailOffer.subject);
    const availableDaysDisplay = getDayLabels(placementDisplay.availableDays);
    let { offerStartDetail, offerEndDetail } = detailOffer;
    let { description } = detailOffer || "";
    const descriptionDisplay = description
      ? description.replace(/<(?:.|\n)*?>/gm, "")
      : "";

    offerStartDetail = moment.utc(offerStartDetail).format("YYYY-MM-DD");
    offerEndDetail = moment.utc(offerEndDetail).format("YYYY-MM-DD");

    return (
      <div>
        <GridContainer justify="center">
          <Dialog
            title={titleDialog}
            content={content}
            open={open}
            onOk={() => this.setState({ open: false })}
          />
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardBody>
                <GridContainer justify="center">
                  {this._renderOfferImages()}
                  <GridItem xs={12} sm={12} md={12}>
                    <List>
                      <ListItem>
                        {edit ? (
                          <TextField
                            label="Title"
                            name="offerTitleEdit"
                            value={offerTitleEdit}
                            onChange={this.handleChange}
                            fullWidth
                            className={classes.textField}
                          />
                        ) : (
                          <Typography component="p" className={classes.textTitle}>
                            {title}
                          </Typography>
                        )}
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={6}>
                            {edit ? (
                              <TextField
                                label="Regular Price"
                                name="offerRegularPriceEdit"
                                value={offerRegularPriceEdit}
                                onChange={this.handleChange}
                                type="number"
                                fullWidth
                                className={classes.textField}
                                inputProps={{ min: 0, step: "any" }}
                              />
                            ) : (
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                Regular Price: ${regularPrice != null ? regularPrice : ""}
                              </Typography>
                            )}
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            {edit ? (
                              <TextField
                                label="Offer Price"
                                name="offerPriceEdit"
                                value={offerPriceEdit}
                                onChange={this.handleChange}
                                type="number"
                                fullWidth
                                className={classes.textField}
                                inputProps={{ min: 0, step: "any" }}
                              />
                            ) : (
                              <Typography
                                component="p"
                                className={classes.textOfferPrice}
                              >
                                ${offerPrice != null ? offerPrice : ""}
                              </Typography>
                            )}
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        {edit ? (
                          <TextField
                            label="Description"
                            name="offerDescriptionEdit"
                            value={offerDescriptionEdit}
                            onChange={this.handleChange}
                            fullWidth
                            multiline
                            rows={6}
                            className={classes.textField}
                          />
                        ) : (
                          <ExpansionPanel className={classes.boxDescription}>
                            <ExpansionPanelSummary
                              expandIcon={<ExpandMoreIcon />}
                              className={classes.headDescription}
                            >
                              <Typography className={classes.textVisited}>
                                Description
                              </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails
                              className={classes.bodyDescription}
                            >
                              <Typography>{descriptionDisplay || ""}</Typography>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        )}
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            {edit ? (
                              <TextField
                                label="Quantity"
                                name="offerQuantitiesEdit"
                                value={offerQuantitiesEdit}
                                onChange={this.handleChange}
                                type="number"
                                fullWidth
                                className={classes.textField}
                                inputProps={{ min: 0, step: 1 }}
                              />
                            ) : (
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                Quantity: {quantities || ""}
                              </Typography>
                            )}
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            {edit ? (
                              <TextField
                                label="Offer Timer (hours)"
                                name="offerTimerEdit"
                                value={offerTimerEdit}
                                onChange={this.handleChange}
                                type="number"
                                fullWidth
                                className={classes.textField}
                                inputProps={{ min: 1, step: 1 }}
                              />
                            ) : (
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                Offer Timer: {offerTimer || ""}
                              </Typography>
                            )}
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <Typography
                              component="p"
                              className={classes.textOfferQuantity}
                            >
                              Sale: {saleOff || ""}
                            </Typography>
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        {!edit ? (
                          <Typography
                            component="p"
                            className={classes.textOfferQuantity}
                          >
                            Target Audience: {subjectDisplay || "-"}
                          </Typography>
                        ) : (
                          <FormControl fullWidth className={classes.textField}>
                            <Typography
                              component="p"
                              style={{ fontSize: 12, color: "#666", marginBottom: 8 }}
                            >
                              Target Audience
                            </Typography>
                            <Select
                              multiple
                              value={offerSubjectEdit || []}
                              onChange={this.handleOfferSubjectChange}
                              renderValue={(selected) => {
                                const labels = OFFER_SUBJECTS
                                  .filter((item) => selected.includes(item.value))
                                  .map((item) => item.label);
                                return labels.join(", ");
                              }}
                            >
                              {OFFER_SUBJECTS.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                      </ListItem>
                      <ListItem>
                        {!edit ? (
                          <Typography
                            component="p"
                            className={classes.textOfferQuantity}
                          >
                            Available Days: {availableDaysDisplay || "-"}
                          </Typography>
                        ) : (
                          <div style={{ width: "100%" }}>
                            <Typography
                              component="p"
                              style={{ fontSize: 12, color: "#666", marginBottom: 8 }}
                            >
                              Available Days
                            </Typography>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              {OFFER_WEEK_DAYS.map((day) => (
                                <FormControlLabel
                                  key={day.value}
                                  control={(
                                    <Checkbox
                                      checked={(offerAvailableDaysEdit || []).includes(day.value)}
                                      onChange={() => this.handleOfferDayToggle(day.value)}
                                      color="primary"
                                    />
                                  )}
                                  label={day.label}
                                />
                              ))}
                            </div>
                          </div>
                        )}
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            {!edit ? (
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                Start Hour: {placementDisplay.startHour || "-"}
                              </Typography>
                            ) : (
                              <TextField
                                label="Start Hour"
                                type="time"
                                name="offerStartHourEdit"
                                value={offerStartHourEdit || ""}
                                onChange={this.handleChange}
                                fullWidth
                                className={classes.textField}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            {!edit ? (
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                End Hour: {placementDisplay.endHour || "-"}
                              </Typography>
                            ) : (
                              <TextField
                                label="End Hour"
                                type="time"
                                name="offerEndHourEdit"
                                value={offerEndHourEdit || ""}
                                onChange={this.handleChange}
                                fullWidth
                                className={classes.textField}
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            <Typography
                              component="p"
                              className={classes.textOfferQuantity}
                            >
                              Offer Start:
                            </Typography>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <TextField
                              label="Next appointment"
                              type="date"
                              defaultValue={offerStartDetail}
                              className={classes.textField}
                              onChange={this.onChangeTime("offerStartDetail")}
                              disabled={!edit}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            <Typography
                              component="p"
                              className={classes.textOfferQuantity}
                            >
                              Offer End:
                            </Typography>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <TextField
                              label="Next appointment"
                              type="date"
                              defaultValue={offerEndDetail}
                              className={classes.textField}
                              onChange={this.onChangeTime("offerEndDetail")}
                              disabled={!edit}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        {!edit ? (
                          <Typography
                            component="p"
                            className={classes.textOfferQuantity}
                          >
                            Category: {category ? category.name : ""}
                          </Typography>
                        ) : (
                          <GridContainer style={{ width: "100%" }}>
                            <GridItem xs={12} sm={12} md={4}>
                              <Typography
                                component="p"
                                className={classes.textOfferQuantity}
                              >
                                Select Category:{" "}
                              </Typography>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={8}>
                              <form className={classes.root} autoComplete="off">
                                <FormControl className={classes.formControl}>
                                  <Select
                                    value={categoryId || category.id}
                                    onChange={this.handleChange}
                                    inputProps={{
                                      name: "categoryId",
                                      id: "categoryId-simple",
                                    }}
                                  >
                                    {listCategory.length > 0
                                      ? listCategory.map((item, i) => (
                                          <MenuItem key={i} value={item.id}>
                                            {item.name}
                                          </MenuItem>
                                        ))
                                      : null}
                                  </Select>
                                </FormControl>
                              </form>
                            </GridItem>
                          </GridContainer>
                        )}
                      </ListItem>
                      <ListItem>
                        <Typography
                          component="p"
                          className={classes.textOfferQuantity}
                        >
                          Merchant: {merchant ? merchant.username : ""}
                        </Typography>
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            <Typography
                              component="p"
                              className={classes.textOfferQuantity}
                            >
                              Offer Active:
                            </Typography>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Switch
                              classes={{ root: classes.switchRoot }}
                              defaultChecked={active}
                              disabled={!edit}
                              onChange={this.handleSwitchChange("active")}
                              name="active"
                            />
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem>
                        <GridContainer style={{ width: "100%" }}>
                          <GridItem xs={12} sm={12} md={4}>
                            <Typography
                              component="p"
                              className={classes.textOfferQuantity}
                            >
                              Offer Public:
                            </Typography>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Switch
                              classes={{ root: classes.switchRoot }}
                              defaultChecked={status === OfferStatus.PUBLISHED}
                              disabled={!edit}
                              onChange={this.handleSwitchChange("status")}
                              name="status"
                            />
                          </GridItem>
                        </GridContainer>
                      </ListItem>
                      <ListItem className={classes.buttonEdit}>
                        {!edit ? (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={this.onEdit}
                          >
                            <Typography
                              component="p"
                              className={classes.textEdit}
                            >
                              Edit
                            </Typography>
                            <FaEdit color="#ffffff" size={16} />
                          </Button>
                        ) : (
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.onCancelEdit}
                                disabled={saving}
                              >
                                <Typography
                                  component="p"
                                  className={classes.textEdit}
                                >
                                  Cancel
                                </Typography>
                              </Button>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.onSave}
                                disabled={saving}
                              >
                                <Typography
                                  component="p"
                                  className={classes.textEdit}
                                >
                                  {saving ? "Saving..." : "Save"}
                                </Typography>
                                <FaSave color="#ffffff" size={16} />
                              </Button>
                            </GridItem>
                          </GridContainer>
                        )}
                      </ListItem>
                    </List>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          {this._renderStore()}
        </GridContainer>
      </div>
    );
  }
}

// Khai bao PropsType

// Mark: default props
Detail.defaultProps = {
  classes: {},
  listCategory: [],
  detailOffer: {},
  loading: false,
  loadingListCategory: false,
  updateOfferByAdmin: () => {},
};

// Mark: PropsType
Detail.propTypes = {
  classes: PropTypes.object,
  listCategory: PropTypes.array,
  detailOffer: PropTypes.object,
  loading: PropTypes.bool,
  loadingListCategory: PropTypes.bool,
  updateOfferByAdmin: PropTypes.func,
};

// Mark: Map data grapql to props
const DetailOfferById = graphql(getOfferByAdmin, {
  props: ({ data, ownProps }) => ({
    loading: data.loading,
    detailOffer: data.getOfferByAdmin,
    refetchDetailOffer: () => {
      data.refetch({ id: Number(ownProps.match.params.id) });
    },
  }),
  options: (props) => {
    return {
      variables: { id: Number(props.match.params.id) },
      fetchPolicy: "cache-and-network",
    };
  },
});

const ListCategory = graphql(getAllCategories, {
  props: ({ data }) => ({
    loadingListCategory: data.loading,
    listCategory: data.getAllCategories,
  }),
});

const Update = graphql(updateOfferByAdmin, { name: "updateOfferByAdmin" });

export default withStyles(styles)(
  compose(
    DetailOfferById,
    ListCategory,
    Update
  )(Detail)
);
